import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { votingTool } from './VotingTool';

export const votingToolboxItem = ToolboxItem({
    id: 'votingTool',
    label: 'Voting',
    weight: 1050,
    tools: [votingTool]
});
